export default __webpack_public_path__ + "static/media/logo.64f76b61.png";